<template>
    <v-form ref="etapeChoixProgramme" id="etapeChoixProgramme" v-model="$storeCandidature.etapeCoixProgrammeValide" lazy-validation>
        <v-container grid-list-md text-xs-center>
            <v-layout row wrap xs12>
                <Comp_Identite v-on:Valide="validateForm()" v-if="etape == 1"></Comp_Identite>
            </v-layout>
            <v-layout row wrap xs12>
                <v-flex xs4 v-if="etape == 1">
                    <Comp_Email></Comp_Email>
                </v-flex>
                <v-flex xs4 v-if="etape == 1">
                    <Comp_Telephone :telephone=$storeCandidature.sasCandidature.Identification.Telephone></Comp_Telephone>
                </v-flex>
            </v-layout>
            <v-layout row wrap xs12>
                <v-flex xs4 v-if="!$storeCandidature.configurationClient.Loaded || ($storeCandidature.sasCandidature.Ecole
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIsbe
                        && $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireSupCareerVaeId
                        && $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireBachelorsBba)">
                    <v-autocomplete class="pt-0" :items="$storeCandidature.filtreProgrammeListes.RentreesProgrammesList"
                                    v-model="$storeCandidature.sasCandidature.ChoixProgramme.Rentree"
                                    :label="$storeCandidature.langueFormulaire == 'en' ? 'Start Date' : 
                                    ($storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleSupDePub ||
                                    $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleInseecMscMba ? 'Rentrée' : 'Session')"
                                    :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                    item-value="Id"
                                    return-object
                                    chips
                                    deletable-chips
                                    :rules="[$rules.required($storeCandidature.langueFormulaire)]"
                                    @change="filtrerProgrammes()">
                    </v-autocomplete>
                </v-flex>
                <v-flex xs4 v-if="!$storeCandidature.configurationClient.Loaded || ($storeCandidature.sasCandidature.Ecole && $storeCandidature.configurationClient
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleSupCareer
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleEce
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIdDBA
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIdPHD
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleEceTech)">
                    <v-autocomplete class="pt-0" :items="$storeCandidature.filtreProgrammeListes.NiveauxAdmissionList"
                                    v-model="$storeCandidature.sasCandidature.ChoixProgramme.NiveauAdmission"
                                    :label="$storeCandidature.langueFormulaire == 'en' ? 'Level of studies you are applying for' : 'Niveau d\'admission'"
                                    return-object
                                    :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                    item-value="Id"
                                    :rules="[$rules.required($storeCandidature.langueFormulaire)]"
                                    chips
                                    deletable-chips
                                    @change="filtrerProgrammes()">
                    </v-autocomplete>
                </v-flex>
                <v-flex xs4 v-if="$storeCandidature.configurationClient && $storeCandidature.configurationClient.ParamFormulaire.Multingue
                        && $storeCandidature.configurationClient
                        && $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireEsceInternationaleId">
                    <v-autocomplete class="pt-0" :items="$storeCandidature.filtreProgrammeListes.LangueEtudeList"
                                    v-model="$storeCandidature.sasCandidature.ChoixProgramme.LangueEtude"
                                    :label="$storeCandidature.langueFormulaire == 'en' ? 'Language of study' : 'Langue d\'étude'"
                                    :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                    item-value="Id"
                                    return-object
                                    chips
                                    deletable-chips
                                    @change="filtrerProgrammes()">
                    </v-autocomplete>
                </v-flex>
                <v-flex xs4 v-if="!$storeCandidature.configurationClient.Loaded || ($storeCandidature.sasCandidature.Ecole &&
                        $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleInternational)">
                    <v-autocomplete class="pt-0" :items="$storeCandidature.filtreProgrammeListes.EcolesProposees"
                                    v-model="$storeCandidature.sasCandidature.ChoixProgramme.EcoleChoisie"
                                    :label="$storeCandidature.langueFormulaire == 'en' ? 'School' : 'Ecole'"
                                    :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                    item-value="Id"
                                    return-object
                                    chips
                                    deletable-chips
                                    :rules="[$rules.required($storeCandidature.langueFormulaire)]"
                                    @change="filtrerProgrammes()">
                    </v-autocomplete>
                </v-flex>
                <v-flex xs4 v-if="!$storeCandidature.configurationClient.Loaded || ($storeCandidature.sasCandidature.Ecole && $storeCandidature.configurationClient) &&
                         ($storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleHeip
                         || $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleIdCeds
                         || $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleInternational
                         || $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleSupDigital
                         || $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleIsbe
                         || $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleInseecBba
                         || $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleInseecBachelors
                         || $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdBtsInseec
                         || $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleInseecMscMba
                         || $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleSupDePub)">
                    <v-autocomplete class="pt-0" :items="$storeCandidature.filtreProgrammeListes.CampusList"
                                    v-model="$storeCandidature.sasCandidature.ChoixProgramme.Campus"
                                    label="Campus"
                                    :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                    item-value="Id"
                                    :rules="[$rules.required($storeCandidature.langueFormulaire)]"
                                    return-object
                                    chips
                                    deletable-chips
                                    @change="campusChanged()">
                    </v-autocomplete>
                </v-flex>
            </v-layout>
            <!--Pour masterinseec-->
            <div v-if="!$storeCandidature.configurationClient.Loaded || ($storeCandidature.sasCandidature.Ecole &&
                        $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleInseecMscMba)">
                <Comp_SessionsMaster v-on:Valide="validateForm()"></Comp_SessionsMaster>
            </div>
            <!--Autres que masterinseec-->
            <v-layout row wrap xs12 v-if="!$storeCandidature.configurationClient.Loaded || ($storeCandidature.sasCandidature.Ecole &&
                        $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInseecMscMba)">
                <v-flex xs8>
                    <v-autocomplete class="pt-0" :items="listeProgrammeTriee"
                                    v-model="$storeCandidature.sasCandidature.ChoixProgramme.NomProgramme"
                                    :label="$storeCandidature.langueFormulaire == 'en' ? 'Program' : 'Nom du programme'"
                                    :item-text="$storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleInternational ? 'SpecialiteInternationale' : 'Specialite'"
                                    item-value="Id"
                                    :rules="[$rules.required($storeCandidature.langueFormulaire)]"
                                    @change="$storeCandidature.candidatureChanged = true"
                                    return-object
                                    chips
                                    deletable-chips>
                    </v-autocomplete>
                    <div v-if="$storeCandidature.sasCandidature.Identification && $storeCandidature.sasCandidature.Identification.SpecialiteEtudes" class="text-xs-left teal--text text--darken-2 pt-0">
                        {{$storeCandidature.sasCandidature.Identification.NiveauEtudes.Lang00}} /
                        {{$storeCandidature.sasCandidature.Identification.TypeEtudes.Lang00}} /
                        {{$storeCandidature.sasCandidature.Identification.SpecialiteEtudes.Lang00}}
                    </div>
                </v-flex>
            </v-layout>
            <v-layout row wrap xs12 v-if="$storeCandidature.dataIdFormulaireCandidature == $storeCandidature.configurationClient.DescIdFormulaireSupCareerCoursSoirId">
                <v-flex xs4>
                    <v-autocomplete class="pt-0" :items="$storeCandidature.configurationClient.ModeDeFinancementList"
                                    v-model="$storeCandidature.sasCandidature.Identification.ModeDeFinancement"
                                    :label="$storeCandidature.langueFormulaire == 'en' ? 'Funding method' : 'Mode de finacement'"
                                    :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                    item-value="Id"
                                    return-object
                                    chips
                                    deletable-chips
                                    @change="$storeCandidature.candidatureChanged = true">
                    </v-autocomplete>
                </v-flex>
                <v-flex>
                    <v-switch :label="$storeCandidature.langueFormulaire == 'en' ? 'Certify that you are aware of the prerequisites related to the chosen program (In accordance with the government texts on the free choice of training courses)' : 'J\'atteste avoir connaissance des prérequis liés au programme choisi (Conforme aux textes du gouvernement du libre choix des formations)'"
                              v-model="$storeCandidature.sasCandidature.ChoixProgramme.AttestePrerequisProgramme">
                    </v-switch>
                </v-flex>
            </v-layout>
            <v-layout row wrap xs12 v-if="etape == 1">
                <Comp_Consentement></Comp_Consentement>
            </v-layout>
            <v-layout row wrap xs12 v-if="$storeCandidature.configurationClient.ParamFormulaire.ListeSessionsConcoursAAffciher && $storeCandidature.configurationClient.ParamFormulaire.ListeSessionsConcoursAAffciher.length > 0">
                <br />
                <Comp_SessionsConcours :modeValidation="false"></Comp_SessionsConcours>
            </v-layout>
            <!--Variable caché pour la validation du choix de la session-->
            <v-text-field class="pl-3" label="Session choisie" v-show="false"
                          :value="$storeCandidature.sasCandidature.SessionChoisie && $storeCandidature.sasCandidature.SessionChoisie.Id"
                          :rules="[$rules.sessionCochee($storeCandidature.configurationClient.ParamFormulaire.ListeSessionsConcoursAAffciher, $storeCandidature.sasCandidature.SessionChoisie,$storeCandidature.langueFormulaire)]"
                          placeholder=" ">
            </v-text-field>
        </v-container>
    </v-form>
</template>
<script>
    import Comp_Identite from "../components/CompIdentite";
    import Comp_Email from "../components/CompEmail";
    import Comp_Telephone from "../components/CompTelephone";
    import Comp_SessionsMaster from "../components/CompSessionsMaster";
    import Comp_Consentement from "../components/CompConsentement";
    import Comp_SessionsConcours from "../components/CompSessionsConcours";

    export default {
        props: {
            etape: {
                required: true,
                default: 2
            }
        },

        components: {
            Comp_Identite,
            Comp_Email,
            Comp_Telephone,
            Comp_SessionsMaster,
            Comp_Consentement,
            Comp_SessionsConcours,
        },

        data() {
            return {
                // Réaffecter l'objet global pour forcer la maj en temps réel
                $storeCandidature: this.$storeCandidature
            };
        },

        computed: {
            // Liste de triée par spécialités selon le formulaire.
            listeProgrammeTriee() {
                // Si une liste de filtré de programme.
                if (this.$storeCandidature.filtreProgrammeListes && this.$storeCandidature.filtreProgrammeListes.ProgrammesList) {

                    // Si le formulaire est l'international on retourne la liste des spécialité internatinales triées.
                    if (this.$storeCandidature.sasCandidature.Ecole.Id == this.$storeCandidature.configurationClient.DataIdEcoleInternational) {
                        return this.$storeCandidature.filtreProgrammeListes.ProgrammesList.filter(x => x.SpecialiteInternationale).slice().sort((a, b) => a.SpecialiteInternationale.localeCompare(b.SpecialiteInternationale))
                    }
                    // sinon liste des programmes triées par spécialités.
                    else {
                        return this.$storeCandidature.filtreProgrammeListes.ProgrammesList.filter(x => x.Specialite).slice().sort((a, b) => a.Specialite.localeCompare(b.Specialite))
                    }
                }
                return null
            }
        },

        methods: {
            validateForm() {
                this.$refs.etapeChoixProgramme.validate();
            },

            // Evenèment à appeler quand un champ filtrant les programmes est changé
            filtrerProgrammes() {
                this.$storeCandidature.chargerProgrammes(this.$storeCandidature.sasCandidature.Ecole.Id, true)
                this.$storeCandidature.candidatureChanged = true
            },

            // Si le campus est changé, on initialise la session concours choisie
            campusChanged() {

                for (var i = 0; i < this.$storeCandidature.configurationClient.ParamFormulaire.ListeSessionsConcoursAAffciher.length; i++) {
                    this.$storeCandidature.configurationClient.ParamFormulaire.ListeSessionsConcoursAAffciher[i].ChoixOk = false
                }

                this.filtrerProgrammes()
                this.$storeCandidature.sasCandidature.SessionChoisie = null
            }
        },

        mounted() {
            if (this.$refs.etapeChoixProgramme) {
                this.$refs.etapeChoixProgramme.validate()
            }
        },
    };
</script>